import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Ui::Page>\n  {{outlet}}\n</Ui::Page>",{ moduleName: "garaje/pods/property/visitors/blocklist/template.hbs" })